module.exports = __webpack_public_path__ + "img/button_share.f90cf617.png";